import React from "react";
import { Grid, Tooltip, Avatar, Box } from "@mui/material";
import { useGetByReference } from "../../hooks/useGetByReference";
import { useReferenceData } from "../../hooks/useReferenceData";

const Personal = ({ responsables = {}, name }) => {
  const { data } = useGetByReference(responsables);
  const { referenceData } = useReferenceData(responsables);

  const combinedData = data.length ? data : referenceData;

  //  Detectar servidor
  if (responsables?.responsable === "Servidor") {
    return (
      <Grid container justifyContent="center">
        <Tooltip arrow title="Servidor">
          <Box
            component="img"
            sx={{ width: 45, height: 45,aspectRatio: 1 }}
            src="https://centromedicomedam.com/IMG/styled_icons/Servidor/Servidor.png"
          />
        </Tooltip>
      </Grid>
    );
  }

  if (!combinedData || !combinedData.length) {
    return (
      <Grid container justifyContent="center">
        <Tooltip arrow title="Sin asignar">
          <Avatar
            sx={{ width: 45, height: 45, marginRight: 1 }}
            src="https://www.movicaremx.com/IMG/app_mobile/FormatPNG/Perfil/Ajolomovi_H.png"
          />
        </Tooltip>
      </Grid>
    );
  }

  return (
    <Grid container alignItems="center" justifyContent="center">
      {combinedData.map((doc, index) => (
        <React.Fragment key={index}>
          <Tooltip title={doc?.DatosPersonales?.nombre || "Sin asignar"}>
            <Avatar
              alt={doc?.DatosPersonales?.nombre}
              src={doc?.imagen}
              style={{ marginLeft: 5 }}
            />
          </Tooltip>
          {name ? " " + (doc?.DatosPersonales?.nombre || "Sin asignar") : null}
        </React.Fragment>
      ))}
    </Grid>
  );
};
export default Personal;
